import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ZenithComponentsModule } from '@mateco/zenith-webcomponents-angular/dist/zenith-webcomponents-angular';
import { ImpersonationService } from '../../services/impersonation.service';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-impersonation-badge',
  standalone: true,
  imports: [TranslateModule, ZenithComponentsModule, RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (activeImpersonationDriverLoginEmail(); as driverLoginEmail) {
    <zenith-badge
      zn-appearance="warning"
      zn-icon-name="danger"
      [attr.zn-tooltip]="driverLoginEmail"
      [routerLink]="['/new/admin/impersonate']"
      class="clickable"
      >{{ 'header.impersonation.badge.short-text' | translate }}
    </zenith-badge>
    }
  `
})
export class ImpersonationBadgeComponent {
  private readonly impersonationService = inject(ImpersonationService);
  readonly activeImpersonationDriverLoginEmail = this.impersonationService.activeImpersonationDriverLoginEmail;
}
